<template>
  <div>
    <TeacherBreadcrumbs
      :char-count="{
        sm: Infinity,
        md: Infinity,
        xl: Infinity,
        '2xl': Infinity,
      }"
    />
    <NuxtPage :districts="districts?.data?.value" />
  </div>
</template>

<script setup>
const crumbsStore = useBreadcrumbsStore();
const { districts } = useDistricts();

crumbsStore.setCrumbs({
  key: 'parent',
  value: {
    title: `Пункт назначения – Россия`,
    slug: `/destination`,
    preamble: `<strong>Просто выбери маршрут и узнавай Россию как настоящий путешественник.</strong><br><br>«Пункт назначения — Россия» позволяет совместить туризм и историческое просвещение как внутри региона, так и в путешествиях по родной стране. Материалы предназначены для групповой работы под руководством и по инициативе педагога-предметника, так и для индивидуальных познавательных туров. <br><br>Раздел разработан Российским военно-историческим обществом и Агентством развития внутреннего туризма, также в раздел включены образовательные программы путешествий и детские творческие проекты — Азбуки символов регионов, разработанные региональными проектными командами и школьными командами в рамках реализации Международной программы «Классная страна», реализуемой Агентством стратегических инициатив при поддержке Минпросвещения России, Минэкономразвития России и АНО «Национальные приоритеты».`,
  },
});

onBeforeRouteLeave((to) => {
  if (!to.path.includes('destination')) {
    crumbsStore.clearCrumbs();
  }
});

useHead({
  title:
    'Пункт назначения – Россия | Читать на Федеральном портале Истории России',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      name: 'keywords',
      content:
        'Пункт назначения – Россия | История РФ: статьи для школьников и студентов',
    },
  ],
});
</script>
